/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnitResponse
 */
export interface UnitResponse {
    /**
     * 
     * @type {number}
     * @memberof UnitResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitResponse
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof UnitResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UnitResponse
     */
    symbol?: string;
}

/**
 * Check if a given object implements the UnitResponse interface.
 */
export function instanceOfUnitResponse(value: object): value is UnitResponse {
    return true;
}

export function UnitResponseFromJSON(json: any): UnitResponse {
    return UnitResponseFromJSONTyped(json, false);
}

export function UnitResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnitResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'symbol': json['symbol'] == null ? undefined : json['symbol'],
    };
}

export function UnitResponseToJSON(json: any): UnitResponse {
    return UnitResponseToJSONTyped(json, false);
}

export function UnitResponseToJSONTyped(value?: UnitResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'symbol': value['symbol'],
    };
}

